import React from "react";
import { Wrapper } from "./_.styled";

// Page component creates a consistent layout by applying space between items within the page
const Page = ({ children, ...props }) => {
  return <Wrapper {...props}>{children}</Wrapper>;
};

export default Page;
